import React, { useEffect, useRef } from 'react'
import classnames from 'classnames'
import Subtitle from '../Subtitle'
import Header, { HeaderProps } from '../Header'
import { DolaThemes } from '../../styles/types'
import StandardVerticalSpace from '../../styles/StandardVerticalSpace'
import Notification from '../Notification'
import { ContentWrapper, HeaderFiller, Screen } from './styles'
import { useNotification } from '../../provider/NotificationProvider'

interface ScreenProps {
  header?: HeaderProps
  subtitle?: React.ReactChild
  footer?: React.ReactChild
  className?: string
  contentWrapper?: {
    id?: string
    styles?: string
  }
  theme?: DolaThemes
}

const DolaScreen: React.FC<ScreenProps> = ({
  children,
  className = '',
  contentWrapper,
  subtitle,
  header,
  footer,
  theme = 'light',
}) => {
  const screen = useRef<HTMLDivElement>(null)
  const { notification } = useNotification()

  const scrollToTop = () => {
    screen?.current?.scrollTo({
      top: 0,
    })
  }

  useEffect(() => {
    scrollToTop()
  }, [])

  const hasNotification = !!notification.message

  return (
    <>
      <Screen
        className={classnames('screen', {
          [className]: !!className,
        })}
        hasNotification={hasNotification}
        dolaTheme={theme}
        ref={screen}
      >
        {header && (
          <Header
            rightItem={header.rightItem}
            title={header.title}
            subtitle={header.subtitle}
            subheader={header.subheader}
            theme={theme}
          />
        )}
        <ContentWrapper
          className="screen__content-wrapper"
          id={contentWrapper?.id}
          overrides={contentWrapper?.styles}
        >
          {header && <HeaderFiller subheader={!!header.subheader} />}
          {subtitle && (
            <>
              <StandardVerticalSpace />
              <Subtitle
                theme={theme}
                bottomOnly={!!header?.subheader}
                subtitle={subtitle}
              />
            </>
          )}
          {children}
          {footer}
        </ContentWrapper>
      </Screen>
      <Notification scrollToTop={scrollToTop} />
    </>
  )
}

export default DolaScreen
